<template>
  <div class="row">
    <div class="col-md-12"></div>
    <div class="col-md-12 card">
      <div class="card-header">
         <div class="row">
            <div class="col-md-9">
              <h4 class="title">{{ $t('post_templates') }}</h4>
            </div>
            <div class="col-md-3">
              <p-button class="btn btn-primary pull-right" @click="createPageTemplateBuilder">
                <i class="fa fa-plus"></i>  {{ $t('new_page_template') }}
              </p-button>
            </div>
         </div>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input
                class="input-sm"
                :placeholder="$t('search')"
                v-model="searchQuery"
                addon-right-icon="nc-icon nc-zoom-split"
              ></fg-input>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <el-table v-loading="loading"
            :element-loading-text="$t('loading_data') + '...'" class="table-striped" :data="paginated" border style="width: 100%">
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
            <el-table-column :min-width="120" fixed="right" class-name="td-actions text-center" :label="$t('actions')">
              <template slot-scope="props">
                <p-button type="primary" size="sm" icon @click="handleEdit(props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-trash"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </div>

      <div class="card-footer">
        <paginate :pagination="pagination" :metadata="metaData" :allData="getPostTemplates"></paginate>
      </div>

    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Paginate from '../../../UIComponents/Paginate.vue';
import Sidebar from "src/sidebarLinks.js";
import { Message, Form } from "element-ui";

import Con from "@/util/helpers.js";
import Resource from "@/util/Api/resource.js";
import { fetchPageTemplates_2 } from '@/util/Api/pageTemplate.js';
const DeletePageResource = new Resource("postTemplate/delete");
const PostTemplateResource = new Resource("postTemplate");

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    PPagination,
    Paginate
  },
  data() {
    return {
      pagination: {
          perPage: 10,
          perPageOptions: [10, 20, 30, 60, 500, 1000],
          currentPage:1,
          nextPage:'',
          prevPage:'',
          total:'',
          from:'',
          to:'',
          page:'',
      },
      searchQuery: "",
      propsToSearch: ["name"],
      tableColumns: [
        {
          prop: "title",
          label: "Title",
          minWidth: 200
        }, {
          prop: "created_at",
          label: "Created Date"
        }
      ],
      metaData: {
         meta:'',
         links:''
      },
      tableData: [],
      loading: false,
    };
  },
  computed: {
    queriedData() {
        return Con.filterData(this.tableData, this.searchQuery);
    },

    paginated(){
        return Con.paginateData(this.queriedData, this.pagination);
    },
  },

  methods: {

    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

    handleDelete(index, row) {
      this.$confirm(this.$t("are_you_sure_you_want_to_delete_this_page_template"), "Warning", {
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "btn-danger",
        confirmButtonClass: "btn-primary",
        type: "warning"
      }).then(() => {
          let indexToDelete = this.tableData.findIndex(
            tableRow => tableRow.id === row.id
          );
          if (indexToDelete >= 0) {
            this.form = row;
            DeletePageResource.deleteWithGet(this.form.id)
            .then(response => {
              this.tableData.splice(indexToDelete, 1);
              this.getForms();
              this.showAlertMessage(this.$t("page_template_deleted_successfully"), "success");
            })
            .catch(error => {
               console.log("Error");
            });
          }
        })
        .catch(() => {});
    },

    handleEdit(index, row) {
      localStorage.setItem("postID", row.id);
      this.$router.push({ name: "EditPageTemplate", params: { row: row } });
    },

    async getPostTemplates(page_url) {
        this.loading = true;
        if(page_url) {
          page_url = Con.splitStringLinks(page_url);
        }
        await PostTemplateResource.list(page_url)
        .then(response => {
            this.loading = false;
            if(this.tableData.length > 0){
              this.tableData = [...response.data.data, ...this.tableData];
            } else {
              this.tableData = response.data.data;
            }
            this.metaData.meta = response.data.meta;
            this.metaData.links = response.data.links;
          }).catch(error => {
            console.log('error', error);
            this.loading = false;
        });
    },

    createPageTemplateBuilder() {
       this.$router.push({ name: "CreatePageTemplate" });
    }

  },

  created() {
     this.getPostTemplates();
  },

};
</script>
<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
a.custom-link {
  background-color: #2c2c2c;
  padding: 20px;
  color: white;
  text-transform: uppercase;
  font-weight: 700;
}
a.custom-link:hover {
  background-color: #6bd098;
  color: white;
}
</style>
